/**
 * IMPORTS
 */

import { useMutation } from "@tanstack/react-query";

// caso de uso
import { handleRequestResetPassword } from "@/domain/use-cases/solicitar-recuperacao-senha-usuario";
import { notifyError, notifySuccess } from "@/utils/notify-messages";

export function useSolicitarRecuperacaoSenha() {
  const mutation = useMutation({
    mutationFn: async (email: string) => {
      return await handleRequestResetPassword(email);
    },

    onSuccess: (response) => {
      notifySuccess(
        response?.message ?? "E-mail enviado com sucesso! Verifique sua caixa de entrada."
      );
    },

    onError: (error: any) => {
      notifyError(error.message ?? "Erro ao solicitar recuperação de senha!");
    },
  });

  return {
    solicitarRecuperacao: mutation.mutate,
    solicitarRecuperacaoAsync: mutation.mutateAsync,
    isLoading: mutation.isPending,
    isError: mutation.isError,
    error: mutation.error,
    data: mutation.data,
    isSuccess: mutation.isSuccess,
  };
}
